<template>
  <div class="divide-y divide-border-cart space-y-6">
    <BlockCommentList
      :list="list"
      :td-comment="tdComment"
      :show-load-more="showMore"
      :loading="loading"
      @loadMore="loadMore"
    />
  </div>
</template>

<script>
import BlockCommentList from '@design-system/block/comment/comment-list'
import { mapActions, mapGetters } from 'vuex'
import { GetComment } from './td-comment'
export default {
  name: 'CommonTeacherReviewComments',
  components: {
    BlockCommentList
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    teacher: {
      type: Object,
      default: () => {
      }
    },
    fetchOnMounted: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      page: 1,
      perPage: 5,
      showMore: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters('teacher', ['getFeedbacks', 'getSelectedTeacher'])
  },
  mounted () {
    if (this.fetchOnMounted) {
      this.fetchData()
    } else {
      this.$nextTick(() => {
        this.showMore = this.showMoreLoad()
      })
    }
  },
  methods: {
    ...mapActions('teacher', ['fetchTutorFeedbacks']),
    async fetchData () {
      this.loading = true
      await this.fetchTutorFeedbacks({
        teacherId: this.getSelectedTeacher?.id,
        page: this.page,
        per_page: this.perPage
      })
      this.showMore = this.showMoreLoad()
      this.loading = false
    },
    tdComment (data) {
      return GetComment(data)
    },
    loadMore () {
      this.page++
      this.fetchData()
    },
    showMoreLoad () {
      return this.getFeedbacks?.comments?.length < this.getFeedbacks?.numbers?.total
    }
  }
}
</script>

<style scoped>

</style>
